var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header',{}),_c('div',{staticClass:"fixed-background"},[_c('div',{staticClass:"container pt-3"},[_c('router-view')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }